import React, { useState } from "react";
import { Link } from "react-router-dom";
import { GoEye } from "react-icons/go";
import { RiDeleteBinLine } from "react-icons/ri";
import { toast } from "react-hot-toast";
import { dateFormat } from "../../Context/Functionalty";
import { useDispatch } from "react-redux";
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";

function Table({ dashboard, datas }) {
  const Head = "text-xs font-semibold px-6 py-2 uppercase";
  const Text = "px-5 text-sm py-3 leading-6 whitespace-nowrap";
  const badge = "py-1 px-2 rounded-full text-xs font-semibold";
  const dispatch = useDispatch();

  const deleteHandler = (id) => {
    if (window.confirm("This order will be deleted")) {
      // dispatch(deleteOrderAction(id));
    }
  };

  const renderServiceList = (selected) => {
    if (!selected.length) {
      return <p className="text-sm text-gray-400 italic">None selected</p>;
    }

    return selected.map((item, i) => (
      <div key={i} className="flex items-start space-x-2 mb-2 max-w-[200px]">
        <div className="w-5 h-5 bg-yellowlight rounded-md flex items-center justify-center mt-1 shrink-0">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-3 w-3 text-yellowdark"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M5 13l4 4L19 7"
            />
          </svg>
        </div>
        <div className="max-w-[200px] overflow-hidden">
          <p className="truncate max-w-[200px] overflow-hidden text-ellipsis whitespace-nowrap">
            {item.title}
            {item.desc && (
              <span className="text-sm text-gray-400"> ({item.desc})</span>
            )}
          </p>
        </div>
      </div>
    ));
  };

  const formatDateTime = (dateStr) => {
    const date = new Date(dateStr);
    if (isNaN(date)) return dateStr;

    return new Intl.DateTimeFormat("en-US", {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    }).format(date);
  };

  const Rows = ({ order }) => {
    const isPast =
      order?.selectedDateTime && new Date(order.selectedDateTime) < new Date();

    return (
      <tr>
        <td className={`${Text} text-center`}>
          {dateFormat(order?.createdAt)}
        </td>
        <td className={`${Text} text-center max-w-[200px]`}>
          {renderServiceList(order?.selectedNailServices)}
        </td>
        <td className={`${Text} text-center max-w-[200px]`}>
          {renderServiceList(order?.selectedBeautyServices)}
        </td>
        <td className={`${Text} text-center`}>
          {order?.booking?.status === "booked" && (
            <span
              className={`${badge} ${
                isPast
                  ? "text-gray-400 bg-gray-800"
                  : "text-green-600 bg-green-100"
              }`}
            >
              {isPast ? "completed" : "booked"}
            </span>
          )}
          {order?.booking?.status === "cancelled" && (
            <span className={`${badge} text-flash bg-red-100`}>
              {order?.booking?.status}
            </span>
          )}
        </td>
        <td
          className={`${Text} font-normal text-center truncate max-w-[200px] overflow-hidden`}
        >
          {formatDateTime(order?.selectedDateTime)}
        </td>
        <td className={`${Text} float-right flex gap-2`}>
          {!dashboard && (
            <button
              onClick={() => deleteHandler(order?._id)}
              className="border text-flash border-flash rounded flex-colo w-6 h-6"
            >
              <RiDeleteBinLine />
            </button>
          )}
          <Link
            to={`/bookingdetail/${order?._id}`}
            className="border text-subMain border-subMain rounded flex-colo w-6 h-6"
          >
            <GoEye />
          </Link>
        </td>
      </tr>
    );
  };

  // --- PAGINATION LOGIC ---
  // --- SORTING: Move upcoming bookings to the top ---
  const sortedData = [...datas].sort((a, b) => {
    const now = new Date();
    const aDate = new Date(a.selectedDateTime);
    const bDate = new Date(b.selectedDateTime);

    const aIsUpcoming = aDate >= now;
    const bIsUpcoming = bDate >= now;

    // Put upcoming first
    if (aIsUpcoming && !bIsUpcoming) return -1;
    if (!aIsUpcoming && bIsUpcoming) return 1;

    // If both are in the same group, sort by date (newest first)
    return bDate - aDate;
  });

  const itemsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const startIndex = (currentPage - 1) * itemsPerPage;

  const totalPages = Math.ceil((sortedData.length || 0) / itemsPerPage);
  const currentData = sortedData.slice(startIndex, startIndex + itemsPerPage);

  const handlePageChange = (pageNum) => {
    if (pageNum >= 1 && pageNum <= totalPages) {
      setCurrentPage(pageNum);
    }
  };

  return (
    <div className="w-full relative overflow-hidden">
      <div className="overflow-x-scroll">
        <table className="table-auto min-w-full border border-neutral-500 divide-y divide-gray-200">
          <thead>
            <tr className="bg-yellow-600">
              <th className={`${Head} text-center`}>Book Date</th>
              <th className={`${Head} text-center`}>Nail Services</th>
              <th className={`${Head} text-center`}>Beauty Services</th>
              <th className={`${Head} text-center`}>Status</th>
              <th className={`${Head} text-center`}>Date/Time</th>
              <th className={`${Head} text-end`}>Action</th>
            </tr>
          </thead>
          <tbody className="bg-black divide-y divide-neutral-500">
            {currentData?.map((order) => (
              <Rows key={order?._id} order={order} />
            ))}
          </tbody>
        </table>
      </div>

      {/* PAGINATION BUTTONS */}
      <div className="flex justify-center mt-4 space-x-1 items-center">
        {/* Prev Arrow */}
        <button
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className="p-2 text-white disabled:opacity-30 hover:text-yellow-400 transition"
        >
          <MdKeyboardArrowLeft size={24} />
        </button>

        {/* Page Numbers */}
        {Array.from({ length: totalPages }, (_, i) => (
          <button
            key={i}
            onClick={() => handlePageChange(i + 1)}
            className={`px-3 py-1 text-sm rounded-full font-semibold ${
              currentPage === i + 1
                ? "bg-yellow-500 text-white"
                : "text-white hover:bg-neutral-800"
            }`}
          >
            {i + 1}
          </button>
        ))}

        {/* Next Arrow */}
        <button
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          className="p-2 text-white disabled:opacity-30 hover:text-yellow-400 transition"
        >
          <MdKeyboardArrowRight size={24} />
        </button>
      </div>
    </div>
  );
}

export default Table;
